import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {loadingTablesAC, setErrorAC} from "./authReducer";
import {AxiosError} from "axios";
import {skuFoodApi} from "../api/skuFood";
import {SkuFoodType} from "../common/types";
import {endDS, startSF} from "../common/optionsForDate";

type SkuData = {
    count: number;
    next: string | null;
    previous: string | null;
    results: SkuFoodType[];
};

type InitialStateType = {
    data: SkuData;
    offset: number;
    date: string[];
    cities: string[]
    store_name: string[]
    orderingUnic: string
    orderingPrice: string
    loading: 'idle' | 'pending' | 'succeeded' | 'failed';
    error: string | null;
};

export const slice = createSlice({
    name: 'skufood',
    initialState: {
        data: {
            count: 0,
            next: null,
            previous: null,
            results: [],
        },
        offset: 0,
        date: [startSF, endDS],
        cities: [],
        store_name: [],
        orderingUnic: '',
        orderingPrice: '',
        loading: 'idle',
        error: null,
    } as InitialStateType,
    reducers: {
        changeDateSFAC(state, action) {
            state.date = action.payload;
            state.offset = 0; // Сбрасываем offset
            state.data.results = []; // Очищаем данные
        },
        changeCitySFAC(state, action) {
            state.cities = action.payload
            state.offset = 0;
            state.data.results = [];
        },
        changeMarketSFAC(state, action) {
            state.store_name = action.payload
            state.offset = 0;
            state.data.results = [];
        },
        changeOrderingUnicSFAC(state, action) {
            state.orderingUnic = action.payload
            state.offset = 0;
            state.data.results = [];
        },
        changeOrderingPriceSFAC(state, action) {
            state.orderingPrice = action.payload
            state.offset = 0;
            state.data.results = [];
        },

    },
    extraReducers: builder => {
        builder
            .addCase(fetchSkuFoodTC.pending, (state) => {
                state.loading = 'pending';
            })
            .addCase(fetchSkuFoodTC.fulfilled, (state, action: PayloadAction<SkuData>) => {
                state.loading = 'succeeded';
                state.data = {
                    ...action.payload,
                    results: state.offset === 0 ? action.payload.results : [...state.data.results, ...action.payload.results], // Если offset = 0, заменяем данные, иначе добавляем
                };
                state.offset += 1000;
            })
            .addCase(fetchSkuFoodTC.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchSkuFoodForChartTC.fulfilled, (state, action) => {
                state.data = action.payload;
            })
    },
});

export const fetchSkuFoodTC = createAsyncThunk('skuFood/fetch', async (params: {
    offset: number;
    start_date_from: string;
    end_date_to: string,
    city: string,
    store_name: string,
    ordering: string,
    address: string
}, {dispatch, rejectWithValue}) => {
    try {
        const {offset, start_date_from, end_date_to, city, store_name, ordering, address} = params;
        const res = await skuFoodApi.getData(offset, start_date_from, end_date_to, city, store_name, ordering, address);
        return res.data;
    } catch (err) {
        dispatch(loadingTablesAC('failed'));
        const error = err as AxiosError;

        if (!error.response) {
            throw err;
        }
        dispatch(setErrorAC(error.response.status));
        return rejectWithValue(error.response);
    }
});

export const fetchSkuFoodForChartTC = createAsyncThunk('skuFood/fetchForChart', async (params: {
    start_date_from: string;
    end_date_to: string,
    city: string,
    store_name: string
}, {dispatch, rejectWithValue}) => {
    try {
        const {start_date_from, end_date_to, city, store_name} = params;
        const res = await skuFoodApi.getData(0, start_date_from, end_date_to, city, store_name, '', 'Cредняя цена');


        return res.data;
    } catch (err) {
        dispatch(loadingTablesAC('failed'));
        const error = err as AxiosError;

        if (!error.response) {
            throw err;
        }
        dispatch(setErrorAC(error.response.status));
        return rejectWithValue(error.response);
    }
});


export const {
    changeDateSFAC,
    changeCitySFAC,
    changeMarketSFAC,
    changeOrderingUnicSFAC,
    changeOrderingPriceSFAC
} = slice.actions;
export const skuFoodReducer = slice.reducer;